import { call, take, takeLatest, put } from 'redux-saga/effects'
import { push } from 'react-router-redux'
import NProgress from 'nprogress'

import * as CONST from 'Reducers/Campaigns/const'
import * as ERRORS from 'Reducers/Errors/const'
import { incUIBlockCounter, decBlockCounter } from 'Reducers/UIBlock/actions'
import { callApi } from 'Reducers/apiCall'

import { apiClient } from 'Module/API/Client'
import { getCampaigns as getCampaignsGQL } from '../../Module/graphQL/index'

import { normalizeGraphQLConnection } from '../../shared/graphql/utils'
/**
 * Create city plan
 *
 * @param action
 */
function* createCityPlan(action) {
  const { callbacks, campaignId, payload } = action

  NProgress.start()
  yield put(incUIBlockCounter())

  const response = yield callApi(apiClient.createCityPlan, payload, campaignId)
  const responseJson = yield response.json()

  if (response.ok) {
    yield put({
      type: CONST.CREATE_CITY_PLAN_SUCCESS,
    })
    callbacks.onSuccess()
  } else {
    yield put({
      type: ERRORS.PUSH_API_ERROR,
      error: responseJson,
    })
  }

  yield put(decBlockCounter())
  NProgress.done()
}

/**
 * Edit city plan
 *
 * @param action
 */
function* editCityPlan(action) {
  const { callbacks, cityPlanId, payload } = action

  NProgress.start()
  yield put(incUIBlockCounter())

  const response = yield callApi(apiClient.editCityPlan, payload, cityPlanId)
  const responseJson = yield response.json()

  if (response.ok) {
    yield put({
      type: CONST.CREATE_CITY_PLAN_SUCCESS,
    })
    callbacks.onSuccess()
  } else {
    yield put({
      type: ERRORS.PUSH_API_ERROR,
      error: responseJson,
    })
  }

  yield put(decBlockCounter())
  NProgress.done()
}

/**
 * Delete city plan by id
 *
 * @param action
 */
function* deleteCityPlanById(action) {
  NProgress.start()
  yield put(incUIBlockCounter())

  try {
    const response = yield callApi(
      apiClient.deleteCityPlanById,
      action.cityPlanId,
    )
    const responseJson = yield response.json()

    if (response.ok) {
      yield put({
        type: CONST.DELETE_CITY_PLAN_BY_ID_SUCCESS,
      })
      yield put(push(action.callbackPath))
    } else {
      yield put({
        type: ERRORS.PUSH_API_ERROR,
        error: responseJson,
      })
    }
  } catch (ex) {}

  yield put(decBlockCounter())
  NProgress.done()
}

/**
 * Get campaigns
 */
function* getCampaigns() {
  const response = yield callApi(getCampaignsGQL)
  const responseJson = yield response.json()
  NProgress.start()
  if (responseJson.errors) {
    yield put({
      type: CONST.GET_CAMPAIGNS_ERROR,
      payload: {
        errorMessage: responseJson.errors[0].message,
      },
    })
  } else {
    yield put({
      type: CONST.GET_CAMPAIGNS_SUCCESS,
      payload: {
        campaigns: normalizeGraphQLConnection(responseJson.data.campaigns),
      },
    })
  }

  NProgress.done()
}

/**
 *  Get campaigns by client id
 */
function* getCampaignsByClientId(action) {
  try {
    NProgress.start()
    const response = yield callApi(
      apiClient.getCampaignsByClientId,
      action.clientId,
    )
    const responseJson = yield response.json()

    if (response.ok) {
      yield put({
        type: CONST.GET_CAMPAIGNS_BY_CLIENT_ID_SUCCESS,
        payload: {
          clientViewCampaigns: responseJson,
        },
      })
    } else {
      yield put({
        type: CONST.GET_CAMPAIGNS_BY_CLIENT_ID_ERROR,
        payload: {
          errorMessage: responseJson.message,
        },
      })
    }
  } catch (ex) {}
  NProgress.done()
}

/**
 * Get city plan by id
 */
function* getCityPlanById(action) {
  const { callbacks, cityPlanId } = action

  NProgress.start()

  try {
    const response = yield callApi(apiClient.getCityPlanById, cityPlanId)
    const responseJson = yield response.json()

    if (response.ok) {
      yield put({
        type: CONST.GET_CITY_PLAN_BY_ID_SUCCESS,
        payload: {
          cityPlanById: responseJson,
        },
      })
      callbacks && callbacks.onSuccess(responseJson)
    } else {
      yield put({
        type: CONST.GET_CITY_PLAN_BY_ID_ERROR,
        payload: {
          errorMessage: responseJson.message,
        },
      })
    }
  } catch (ex) {}

  NProgress.done()
}

/**
 * Get payments by campaign id
 *
 * @param action
 */
function* getPaymentsByCampaignId(action) {
  NProgress.start()

  try {
    const response = yield callApi(
      apiClient.getPaymentsByCampaignId,
      action.payload.campaignId,
    )
    const responseJson = yield response.json()

    if (response.ok) {
      yield put({
        type: CONST.GET_PAYMENTS_BY_CAMPAIGN_ID_SUCCESS,
        paymentsByCampaignId: responseJson,
      })
    } else {
      yield put({
        type: ERRORS.PUSH_API_ERROR,
        error: responseJson,
      })
    }
  } catch (ex) {
    yield put({
      type: ERRORS.PUSH_API_ERROR,
      error: null,
    })
  }

  NProgress.done()
}

/**
 * Edit payments by campaign id
 *
 * @param action
 */
function* editPaymentsByCampaignId(action) {
  NProgress.start()

  try {
    const response = yield callApi(
      apiClient.editPaymentsByCampaignId,
      action.campaignId,
      action.body,
    )
    const responseJson = yield response.json()

    if (response.ok) {
      yield put({
        type: CONST.EDIT_PAYMENTS_BY_CAMPAIGN_ID_SUCCESS,
        paymentsByCampaignId: responseJson,
      })
    } else {
      yield put({
        type: ERRORS.PUSH_API_ERROR,
        error: responseJson,
      })
    }
  } catch (ex) {
    yield put({
      type: ERRORS.PUSH_API_ERROR,
      error: null,
    })
  }

  NProgress.done()
}

/**
 * Get city plans by campaign id for flyer codes form
 *
 * @param action
 */
function* getCityPlansByCampaignIdForFlyerCodesForm(action) {
  NProgress.start()

  try {
    const response = yield callApi(
      apiClient.getCityPlansByCampaignId,
      action.campaignId,
    )
    const responseJson = yield response.json()

    if (response.ok) {
      yield put({
        type: CONST.GET_CITY_PLANS_BY_CAMPAIGN_ID_FOR_FLYER_CODES_FORM_SUCCESS,
        payload: {
          cityPlansByCampaignIdForFlyerCodesForm: responseJson,
        },
      })
    } else {
      yield put({
        type: ERRORS.PUSH_API_ERROR,
        error: responseJson,
      })
    }
  } catch (ex) {}

  NProgress.done()
}

/**
 * Upload conversion report (s3)
 *
 * @param action
 */
function* uploadConversionReport(action) {
  const { callbacks = {}, campaignId, payload } = action

  try {
    NProgress.start()
    yield put(incUIBlockCounter())
    const response = yield call(
      apiClient.uploadConversionReport,
      campaignId,
      payload,
      callbacks.onProgress,
    )

    yield put({
      type: CONST.UPLOAD_CONVERSION_REPORT_SUCCESS,
    })
    callbacks.onSuccess && callbacks.onSuccess(response)
  } catch (ex) {
    callbacks.onError && callbacks.onError(ex)
    yield put({
      type: ERRORS.PUSH_API_ERROR,
      error: ex,
    })
  }

  yield put(decBlockCounter())
  NProgress.done()
}

/**
 * Add conversion report
 *
 * @param action
 */
function* addConversionReport(action) {
  const { callbacks = {}, campaignId, payload } = action

  try {
    NProgress.start()
    yield put(incUIBlockCounter())
    const response = yield call(
      apiClient.addConversionReport,
      campaignId,
      payload,
    )
    const responseJson = yield response.json()

    if (response.ok && responseJson.success) {
      yield put({
        type: CONST.ADD_CONVERSION_REPORT_SUCCESS,
      })
      callbacks.onSuccess && callbacks.onSuccess(responseJson)
    } else {
      callbacks.stopLoading && callbacks.stopLoading()
      yield put({
        type: ERRORS.PUSH_API_ERROR,
        error: responseJson,
      })
    }
    if (responseJson.errors && responseJson.errors.length > 0) {
      callbacks.onError && callbacks.onError(responseJson.errors)
    }
  } catch (ex) {
    yield put({
      type: ERRORS.PUSH_API_ERROR,
      error: ex,
    })
  }

  yield put(decBlockCounter())
  NProgress.done()
}

/**
 * Create city plan request watcher
 */
export function* watchCreateCityPlan() {
  yield takeLatest(CONST.CREATE_CITY_PLAN, createCityPlan)
}

/**
 * Edit city plan request watcher
 */
export function* watchEditCityPlan() {
  yield takeLatest(CONST.EDIT_CITY_PLAN, editCityPlan)
}

/**
 * Delete city plan by id request watcher
 */
export function* watchDeleteCityPlanById() {
  yield takeLatest(CONST.DELETE_CITY_PLAN_BY_ID, deleteCityPlanById)
}

/**
 * Get payments by campaign id watcher
 */
export function* watchGetPaymentsByCampaignId() {
  yield takeLatest(CONST.GET_PAYMENTS_BY_CAMPAIGN_ID, getPaymentsByCampaignId)
}

/**
 * Edit payments by campaign id watcher
 */
export function* watchEditPaymentsByCampaignId() {
  yield takeLatest(CONST.EDIT_PAYMENTS_BY_CAMPAIGN_ID, editPaymentsByCampaignId)
}

/**
 * Get campaigns request watcher
 */
export function* watchGetCampaigns() {
  while (true) {
    const action = yield take(CONST.GET_CAMPAIGNS)
    yield call(getCampaigns, action)
  }
}

/**
 * Get campaigns by id request watcher
 */
export function* watchGetCampaignsByClientId() {
  yield takeLatest(CONST.GET_CAMPAIGNS_BY_CLIENT_ID, getCampaignsByClientId)
}

/**
 * Get city plan by id request watcher
 */
export function* watchGetCityPlanById() {
  yield takeLatest(CONST.GET_CITY_PLAN_BY_ID, getCityPlanById)
}

/**
 * Get city plans by campaign id for flyer codes form watcher
 */
export function* watchGetCityPlansByCampaignIdForFlyerCodesForm() {
  yield takeLatest(
    CONST.GET_CITY_PLANS_BY_CAMPAIGN_ID_FOR_FLYER_CODES_FORM,
    getCityPlansByCampaignIdForFlyerCodesForm,
  )
}

/**
 * Upload conversion report watcher
 */
export function* watchUploadConversionReport() {
  yield takeLatest(CONST.UPLOAD_CONVERSION_REPORT, uploadConversionReport)
}

/**
 * Add conversion report
 */
export function* watchAddConversionReport() {
  yield takeLatest(CONST.ADD_CONVERSION_REPORT, addConversionReport)
}



// WEBPACK FOOTER //
// ./src/Reducers/Campaigns/sagas.js